import * as types from '../const/action.types';
import api from '../api/ProcessApi';

export function instanceHasErrored(bool, message) {
    return {
        type: types.INSTANCE_HAS_ERROR,
        hasErrored: bool,
        error: message,
    };
}

export function instanceIsLoading(bool) {
    return {
        type: types.INSTANCE_IS_LOADING,
        isLoading: bool,
    };
}

export function instanceFetchDataSuccess(items) {
    return {
        type: types.INSTANCE_FETCH_DATA,
        items,
    };
}

export function loadForm(id) {
    return async (dispatch) => {
        dispatch(instanceIsLoading(true));
        dispatch(clearInstanceValue());
        dispatch(instanceFetchDataSuccess({}));
        try {
            const response = await api.getFormInstance(id);
            dispatch(instanceIsLoading(false));
            if (response.error !== undefined) {
                throw Error(response);
            }
            const items = response;
            dispatch(instanceHasErrored(false, ''));
            dispatch(instanceFetchDataSuccess(items));
        } catch (error) {
            console.error(error.message);
            dispatch(
                instanceHasErrored(
                    error.type ? error.type : true,
                    error && error.message ? error.message : 'Error accediendo a la información',
                ),
            );
        }
    };
}

export function setValue(
    codigo,
    valor,
    comment = '',
    desactivado = false,
    metadatos = {},
    percentage = 100,
) {
    return {
        type: types.INSTANCE_HANDLE_CHANGE,
        codigo,
        valor,
        comment,
        desactivado,
        metadatos,
        percentage,
    };
}

export function clearInstanceValue() {
    return {
        type: types.CLEAR_INSTANCE_VALUES,
    };
}

export function instanceIsSaving(bool) {
    return {
        type: types.SAVING_INSTANCE_CHANGES,
        isSaving: bool,
    };
}

export function instanceSavingError(bool, message) {
    return {
        type: types.SAVE_INSTANCE_ERROR,
        hasErrored: bool,
        error: message,
    };
}

export function saveInstance(id, changes, local, employee) {
    console.log(changes);
    return async (dispatch) => {
        dispatch(instanceIsSaving(true));
        try {
            const response = await api.updateFields(id, changes, local, employee);
            dispatch(instanceIsSaving(false));
            if (response.error !== undefined) {
                throw Error(response.error);
            }
            const items = response;
            dispatch(instanceSavingError(false, ''));
            dispatch(clearInstanceValue());
            return items;
        } catch (error) {
            dispatch(instanceIsSaving(false));
            throw error;
        }
    };
}

export function instanceInExecution(bool) {
    return {
        type: types.EXECUTING_INSTANCE_TRANSITION,
        inExecution: bool,
    };
}

export function instanceExecuteSuccess(bool, id) {
    return {
        type: types.EXECUTE_INSTANCE_TRANSITION,
        success: bool,
        id: id,
    };
}

export function executeTransition(id, changes, code, local, employee) {
    return async (dispatch) => {
        dispatch(instanceInExecution(true));
        try {
            const response = await api.executeTransition(id, changes, code, local, employee);
            dispatch(instanceInExecution(false));
            if (response && response.error !== undefined) {
                throw Error(response);
            }
            const result = response;
            dispatch(instanceSavingError(false, ''));
            dispatch(instanceExecuteSuccess(result.success === 'true', id));
            dispatch(clearInstanceValue());
            dispatch(instanceFetchDataSuccess({}));
            return result;
        } catch (error) {
            dispatch(instanceInExecution(false));
            throw error;
        }
    };
}



// WEBPACK FOOTER //
// ./src/actions/api.form.actions.js